"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ContentDelivery = _interopRequireDefault(require("../ContentDelivery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ImagePreloader = /*#__PURE__*/function () {
  function ImagePreloader() {
    _classCallCheck(this, ImagePreloader);
  }

  _createClass(ImagePreloader, [{
    key: "preload",
    value:
    /**
     * Preload list of blob resources in parallel requests
     * @param {Array} urls list of blob resources
     * @param {String} requestGroup Request group to cancel requests later
     * @return {Promise}
     */
    function preload(urls) {
      var _this = this;

      var requestGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return Promise.all(urls.map(function (url) {
        return _this.loadImageBlob(url, requestGroup);
      })).then(function (urls) {
        return urls.reduce(function (acc, cur) {
          acc[cur.key] = cur.value;
          return acc;
        }, {});
      });
    }
    /**
     * Loads image blob from specified URL and returns http URL => blob URL mapping
     *
     * @param {String} src
     * @param {String} requestGroup
     * @returns {Promise}
     */

  }, {
    key: "loadImageBlob",
    value: function loadImageBlob(src) {
      var requestGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var promise = _ContentDelivery["default"].get(_objectSpread({
        url: src,
        responseType: 'blob',
        retriable: true
      }, requestGroup ? {
        requestGroup: requestGroup
      } : {}));

      return promise.then(function (response) {
        return response.data;
      }).then(function (blob) {
        return URL.createObjectURL(blob);
      }).then(function (blobUrl) {
        return {
          key: src,
          value: blobUrl
        };
      });
    }
  }]);

  return ImagePreloader;
}();

var _default = new ImagePreloader();

exports["default"] = _default;